<template>
  <div id="app" class="app">
    <component :is="layout">
      <router-view />
    </component>
    <notifications classes="my-notifi" width="360" :duration="2000" position="right top" />
<!--    <div v-else class="app__thumb">Desktop devices are not supported</div>-->
  </div>
</template>

<script>
import PullToRefresh from 'pulltorefreshjs'

export default {
  data() {
    return {
      isMobile: true,
      isStandalone: true,
    }
  },
  computed: {
    layout () {
      return this.$route.meta.layout || 'default'
    }
  },
  created() {
    // const bypassDeviceGuards = process.env.VUE_APP_BYPASS_DEVICE_GUARDS === 'true'
    if (!process.env.VUE_APP_API_URL.includes('dev')) {
      this.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches
      this.isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent) && this.isStandalone) {
      PullToRefresh.init({
        onRefresh() {
          window.location.reload()
        },
      })
    }
  },
}
</script>

<style lang="sass">
#app
  display: flex
  flex-grow: 1

.app__thumb
  flex-grow: 1
  display: flex
  justify-content: center
  align-items: center
  gap: 20px
  height: 100vh
  font-size: 30px
  text-align: center
  font-weight: 600

</style>
